<template>
  <div class="page">
    <div class="left">
      <van-sidebar v-model="activeKey">
        <van-sidebar-item title="最近学习" />
        <van-sidebar-item title="学习中" />
        <van-sidebar-item title="完成课程" />
      </van-sidebar>
    </div>
    <div class="right">
      <div>
        <van-card  v-if="activeKey == 0" :data-item="item" @click="toDetail(item)" :class="item.isInshelf ? '' : 'grey'"
          v-for="(item, index) in list" :key="index">
          <div slot="thumb" style="height: 100%">
            <van-image fit="contain" width="100px" height="100%" :src="item.bg" />
          </div>
          <div slot="title" class="fs14 slh2 td">
            {{ item.title }}
          </div>
          <div v-if="item.last_play.file_title" slot="desc" class="fs13 slh td">
            {{ item.last_play.file_title }}
          </div>
          <div slot="price-top">
            <template v-if="item.last_play_time">
              <div class="red_t">最近学习：{{ item.last_play_time }}</div>
            </template>
            <div class="flex flex_bt progressText">
              <template v-if="item.linktype != 8">
                <div class="green_t">
                  学习进度:{{ item.percent || 0 }}%
                </div>
                <div class="red_t" v-if="item.durationTime">
                  共{{ item.durationTime }}
                </div>
              </template>
            </div>
          </div>
          <div slot="price" v-if="item.linktype != 8">
            <van-progress :show-pivot="false" :color="item.isInshelf ? '#0ddd87' : '#999'"
              :percentage="item.percent ? item.percent : 0" />
          </div>
        </van-card>
        <van-card  v-if="activeKey == 1" :data-item="item" @click="toDetail(item)" :class="item.isInshelf ? '' : 'grey'"
          v-for="(item, index) in list" :key="index">
          <div slot="thumb" style="height: 100%">
            <van-image fit="contain" width="100px" height="100%" :src="item.bg" />
          </div>
          <div slot="title" class="fs14 slh2 td">
            {{ item.title }}
          </div>
          <div v-if="item.last_play.file_title" slot="desc" class="fs13 slh td">
            {{ item.last_play.file_title }}
          </div>
          <div slot="price-top">
            <template v-if="item.last_play_time">
              <div class="red_t">最近学习：{{ item.last_play_time }}</div>
            </template>
            <div class="flex flex_bt progressText">
              <template v-if="item.linktype != 8">
                <div class="green_t">
                  学习进度:{{ item.percent || 0 }}%
                </div>
                <div class="red_t" v-if="item.durationTime">
                  共{{ item.durationTime }}
                </div>
              </template>
            </div>
          </div>
          <div slot="price" v-if="item.linktype != 8">
            <van-progress :show-pivot="false" :color="item.isInshelf ? '#0ddd87' : '#999'"
              :percentage="item.percent ? item.percent : 0" />
          </div>
        </van-card>
        <van-card  v-if="activeKey == 2" :data-item="item" @click="toDetail(item)" :class="item.isInshelf ? '' : 'grey'"
          v-for="(item, index) in list" :key="index">
          <div slot="thumb" style="height: 100%">
            <van-image fit="contain" width="100px" height="100%" :src="item.bg" />
          </div>
          <div slot="title" class="fs14 slh2 td">
            {{ item.title }}
          </div>
          <div v-if="item.last_play.file_title" slot="desc" class="fs13 slh td">
            {{ item.last_play.file_title }}
          </div>
          <div slot="price-top">
            <div class="flex flex_bt progressText">
              <div class="fs13">
                已看：{{ item.info_play_rate }}%
              </div>
              <div class="fs13" v-if="item.durationTime">
                共{{ item.durationTime }}
              </div>

            </div>
          </div>
          <div slot="price" class=" red_t">
            <div>
              最近学习：{{ item.last_play_time }}
            </div>
            <div>
              完成时间：{{ item.complete_time }}
            </div>
          </div>
        </van-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mediaPlanTypeGet } from '@/api/shopapi'
export default {
  data() {
    return {
      activeKey: 0,
      list: []
    };
  },
  watch: {
    activeKey: {
      handler: function () {
        let type = '最近学习'
        if (this.activeKey == 0) {
          type = '最近学习'
        } else if (this.activeKey == 1) {
          type = '学习中'
        } else {
          type = '完成课程'
        }
        this.mediaPlanTypeGet(type)
      },
      immediate: true
    }
  },
  methods: {
    mediaPlanTypeGet(type) {
      this.$toast.loading({ duration: 0, message: '加载中...' })
      let params = {
        category_id: null,
        type
      }
      mediaPlanTypeGet(params).then(res => {
        this.list = res.data
        this.$toast.clear()
      })
    },
    toDetail(info) {
      this.$router.push({ name: "PlayVideo", params: info })
    },
  }
}
</script>
<style scoped>
.page {
  display: flex;
  min-height: calc(100vh - 46px);
  background-color: #eee;
}

.left {
  background-color: #fff;
  width: 80px;
}

.right {
  width: calc(100vw - 80px);
}

.hidden {
  overflow: hidden;
}

.bg {
  width: 100vw;
  position: absolute;
  left: 0;
  top: 0;
}

.header {
  position: relative;
}

.text {
  height: 40vw;
  display: flex;
  align-items: center;
  width: 100vw;
}

.grid .van-grid-item__content {
  background-color: transparent;
}

.grid {
  width: 100vw;
}

.body {
  padding: 0 10px;
}

.shadow {
  border-radius: 5px;
  margin-bottom: 10px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}

.avatar {
  border-radius: 50%;
  overflow: hidden;
  width: 75px;
  height: 75px;
}

.icon {
  padding-left: 5px;
}

.username {
  font-size: 17px;
}

.tips {
  font-size: 13px;
  padding-bottom: 3px;
}

.bd {
  background-color: #fff;
  padding: 10px;
}

.bd .title {
  font-weight: bold;
}

.bd .label {
  font-size: 12px;
}

.showMoreBtn {
  text-align: center;
}

.cover {
  width: 100px;
  height: 57px;
}

.card .van-card__thumb {
  width: 100px;
  height: 57px;
}

.progressText {
  margin-bottom: 5px;
  font-size: 13px;
}

.green_t {
  color: #0ddd87;
}

.red_t {
  color: #fb891a;
}

.nowrap {
  white-space: nowrap;
}

.pm {
  color: #333;
  margin-right: 10px;
}

.zwry {
  margin-left: 5px;
}

.grey {
  color: #999 !important;
}


.xiajia {
  position: absolute;
  left: 5px;
  top: 0;
  color: #fff;
  background-color: #999;
  border-radius: 0 0 10px 10px;
  font-size: 12px;
  width: 20px;
  padding: 5px 2px;
  line-height: 1.2;
  text-align: center;
}

.xiajia.type {
  background-color: rgb(45, 180, 106);
}

.tags_box {
  padding: 15px 10px;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 5px;
  padding-right: 0;
}

.tag {
  color: #BD3124;
  border-radius: 5px;
  background-color: rgba(222, 134, 143, 0.41);
  width: 59px;
  border: 1px solid rgba(222, 134, 143, 0.41);
  font-size: 12px;
  position: relative;
  text-align: center;
  height: 22px;
  line-height: 22px;
  margin-bottom: 7px;
  margin-right: 6px;
}

.tag>.num {
  position: absolute;
  font-size: 12px;
  border-radius: 50%;
  color: #fff;
  right: 0;
  top: -10px;
  background-color: rgba(255, 99, 107, 100);
  width: 18px;
  height: 18px;
  line-height: 18px;
}

.van-tab {
  flex: none !important;
}

.van-ellipsis {
  font-weight: bold;
  padding: 0 5px;
  font-size: 14px;
}

.picker_box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}

.border {
  border: 1px solid rgb(184, 182, 182);
  margin: 0 10px;
  margin-bottom: 5px;
}

.active {
  border: 1px solid #BD3124;
  background-color: #fff;
}

.shixiao {
  background-color: rgb(214, 7, 7);
}

.wancheng {
  background-color: rgb(29, 204, 52);
}

.border .van-cell {
  padding: 5px 8px !important;
}

.dh_item {
  margin-bottom: 10px;
}

.dh_detail {
  background-color: #fff;
  padding: 20px;
}

.two {
  font-size: 13px;
  padding-left: 10px;
  line-height: 1.5;
}

.two>div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.dh_right {
  display: flex;
  align-items: center;
}

.closeDh {
  position: absolute;
  right: 10px;
  top: 15px;
}

.van-card__thumb {
  width: inherit;
}

.red_t {
  color: #fb891a;
}

.td {
  color: #000;
}
</style>